import { helpers  } from 'vuelidate/lib/validators'

export const letters = helpers.regex('letters', /(^[a-zA-ZäÄëËïÏöÖüÜáéíóúáéíóúÁÉÍÓÚÂÊÎÔÛâêîôûàèìòùÀÈÌÒÙÑñ\s]*$)/);
export const dni = helpers.regex('dni', /(^[a-zA-Z0-9]*$)/);
export const phone = helpers.regex('phone',/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/)